import axios from 'axios';
import authHeader from "@/service/auth-header";

class PractitionerService {

    getCompanyPractitioners(companyId) {
        return axios.get(`/api/practitioner/${companyId}`, {headers: authHeader()})
    }

    getAllCompanyPractitioners(companyId) {
        return axios.get(`/api/practitioner/all/${companyId}`, {headers: authHeader()})
    }

    searchCompanyPractitioners(companyId, searchCriteria) {
        return axios.get(`/api/practitioner/${companyId}/${searchCriteria}`, {headers: authHeader()})
    }

    searchAllCompanyPractitioners(companyId, searchCriteria, category) {
        return axios.get(`/api/practitioner/all/${companyId}/${searchCriteria}/${category}`, {headers: authHeader()})
    }

    getPractitioner(practitionerId) {
        return axios.get(`/api/practitioner/specific/${practitionerId}`, {headers: authHeader()})
    }

    createPractitioner(companyId, data) {
        return axios.post(`/api/practitioner/${companyId}`, data, {headers: authHeader()});
    }

    updatePractitioner(practitionerId, data) {
        return axios.put(`/api/practitioner/${practitionerId}`, data, {headers: authHeader()});
    }

    deletePractitioner(practitionerId) {
        return axios.delete(`/api/practitioner/${practitionerId}`, {headers: authHeader()});
    }

}

export default new PractitionerService();
